export const departments = [
    {name: "IT", role: 'it'},
    {name: "Back Office", role: 'backOffice'},
    {name: "ISO", role: 'iso'},
  ];

  export const access = [
    {id: 0, name: 'Administrative Users', value: 'adUsers', rights: ['view']},
    {id: 1, name: 'Clients', value: 'clients', rights: ['view']},
  ];

  export const rights = [
    "create",
    "View",
    "edit",
    "approve",
    // 'export',
  ];